import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import TeslaButton from '../../components/common/TeslaButton';

interface SearchHeaderProps {
  searchQuery: string;
  onSearchChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onFilterOpen: () => void;
}

const SearchHeader: React.FC<SearchHeaderProps> = ({
  searchQuery,
  onSearchChange,
  onFilterOpen
}) => {
  return (
    <HeaderSection>
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <PageTitle>Find Your Stylist</PageTitle>
        <SearchContainer>
          <SearchIcon>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
          </SearchIcon>
          <SearchInput 
            type="text" 
            placeholder="Search stylists..."
            value={searchQuery}
            onChange={onSearchChange}
          />
        </SearchContainer>
        
        <MobileFilterButton>
          <TeslaButton 
            variant="secondary" 
            onClick={onFilterOpen}
            className="filter-button"
          >
            Filter
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" className="ml-2">
              <path d="M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"/>
            </svg>
          </TeslaButton>
        </MobileFilterButton>
      </motion.div>
    </HeaderSection>
  );
};

// Styled components
const HeaderSection = styled.header`
  padding: 40px 0 24px;
  position: relative;
  
  @media (max-width: 768px) {
    padding: 24px 0 16px;
  }
`;

const PageTitle = styled.h1`
  font-size: 42px;
  font-weight: 500;
  margin-bottom: 24px;
  color: #171a20;
  
  @media (max-width: 768px) {
    font-size: 32px;
    margin-bottom: 16px;
  }
`;

const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  max-width: 600px;
  background-color: #f5f5f5;
  border-radius: 4px;
  padding: 0 16px;
  margin-bottom: 24px;
  transition: all 0.2s ease;
  
  &:focus-within {
    box-shadow: 0 0 0 1px #C9A84C;
    background-color: #fff;
  }
`;

const SearchIcon = styled.div`
  color: #5c5e62;
  margin-right: 8px;
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 16px 0;
  border: none;
  background: transparent;
  font-size: 16px;
  outline: none;
  color: #393c41;
  
  &::placeholder {
    color: #5c5e62;
  }
`;

const MobileFilterButton = styled.div`
  display: none;
  position: absolute;
  top: 42px;
  right: 0;
  
  @media (max-width: 768px) {
    display: block;
  }
  
  .filter-button {
    padding: 10px 16px;
  }
`;

export default SearchHeader;